import { render, staticRenderFns } from "./biantengbiao.vue?vue&type=template&id=c0499418&scoped=true&"
import script from "./biantengbiao.vue?vue&type=script&lang=js&"
export * from "./biantengbiao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0499418",
  null
  
)

export default component.exports